module.exports = "/_next/static/images/3081b65e82146784cb35b75b839aaff9-girl_and_pig.svg";